// client/src/hooks/useBoardCallActions.js
// Transfer / end state for one call-board card (dashboard and footer share it).
import { useCallback, useEffect, useRef, useState } from 'react';
import { endBoardCall, transferBoardCall } from '../services/callBoardService';

export default function useBoardCallActions(callId) {
  const [busy, setBusy] = useState(null);     // 'transfer' | 'end' | null
  const [result, setResult] = useState(null); // { success, message }
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);

  const flash = (r, ms = 4000) => {
    setResult(r);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setResult(null), ms);
  };

  const transfer = useCallback(async (destination) => {
    const dest = String(destination || '').trim();
    if (!dest) { flash({ success: false, message: 'Enter an extension or number.' }, 3000); return false; }
    setBusy('transfer');
    const r = await transferBoardCall(callId, dest);
    setBusy(null);
    flash(r);
    return r.success;
  }, [callId]);

  const end = useCallback(async () => {
    setBusy('end');
    const r = await endBoardCall(callId);
    setBusy(null);
    flash(r);
    return r.success;
  }, [callId]);

  return { busy, result, transfer, end };
}
